import type { ErrorEvent } from "@sentry/react";

/**
 * Safari reports these as "Load failed", which is also how it surfaces a
 * cross-origin request blocked by Advanced Tracking & Fingerprinting Protection
 * or Private Browsing.
 */
const RESOURCE_LOAD_ERROR_PATTERN =
  /\bLoad failed|NetworkError when attempting to fetch/i;

/**
 * Whether an event is a generic resource or fetch load failure.
 *
 * Kept at error severity: when Safari's privacy protections block the request,
 * the SDK or map does not render at all, which is a broken experience rather
 * than benign noise.
 */
export const isResourceLoadError = (event: ErrorEvent): boolean =>
  event.exception?.values?.some(
    (value) =>
      RESOURCE_LOAD_ERROR_PATTERN.test(value?.value || "") ||
      RESOURCE_LOAD_ERROR_PATTERN.test(value?.type || ""),
  ) ?? false;
